import React, { useState, useRef } from "react";
import "./account-settings.css";
import { updateUser } from "../../api-interactions/authentication";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const AccountSettings = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [editMode, setEditMode] = useState(false);

  const firstnameRef = useRef();
  const lastnameRef = useRef();
  const emailRef = useRef();

  const updateProfileHandler = async () => {
    setLoading(true);
    const newUser = await updateUser({
      firstName: firstnameRef.current.value,
      lastName: lastnameRef.current.value,
      email: emailRef.current.value,
    });
    setUser(newUser);
    newSuccess("Succesfully updated your profile!");
    setEditMode(false);
    setLoading(false);
  };

  const newSuccess = (message) => {
    setSuccessMsg(message);
    setTimeout(() => {
      setSuccessMsg("");
    }, 3000);
  };

  // const connectGoogleHandler = () => {

  // }

  return (
    <>
      {!loading && (
        <div className="change-settings-container">
          {successMsg && (
            <Snackbar open={true} autoHideDuration={3000}>
              <Alert severity="success">{successMsg}</Alert>
            </Snackbar>
          )}
          <div id="profile-card">
            <img
              src={`https://api.dicebear.com/8.x/initials/svg?seed=${
                user.firstName[0] + user.lastName[0]
              }`}
              alt="profile"
              id="profile-card-image"
            />
            <div id="profile-card-details">
              <p id="profile-card-name">
                {user.firstName} {user.lastName}
              </p>
              <p id="profile-card-username">@{user.userName}</p>
            </div>
          </div>
          <div id="account-settings">
            <div
              id="personal-info-container"
              className="settings-section-container"
            >
              <div id="personal-info-header">
                <h3>Personal information:</h3>
                {!editMode && (
                  <button
                    id="edit-personal-info-button"
                    onClick={() => {
                      setEditMode(true);
                    }}
                  >
                    EDIT
                  </button>
                )}
              </div>
              <div id="personal-info-settings">
                <div className="settings-title">
                  <h4 className="settings-property">First Name</h4>
                  {!editMode ? (
                    <span className="settings-property-info">
                      {user.firstName}
                    </span>
                  ) : (
                    <input
                      className="change-property"
                      type="text"
                      defaultValue={user.firstName}
                      ref={firstnameRef}
                    ></input>
                  )}
                </div>
                <div className="settings-title">
                  <h4 className="settings-property">Last Name</h4>
                  {!editMode ? (
                    <span className="settings-property-info">
                      {user.lastName}
                    </span>
                  ) : (
                    <input
                      className="change-property"
                      type="text"
                      defaultValue={user.lastName}
                      ref={lastnameRef}
                    ></input>
                  )}
                </div>
                <div className="settings-title">
                  <h4 className="settings-property">Email Address</h4>
                  {!editMode ? (
                    <span className="settings-property-info">{user.email}</span>
                  ) : (
                    <input
                      className="change-property"
                      type="text"
                      defaultValue={user.email}
                      ref={emailRef}
                    ></input>
                  )}
                </div>
                <div className="settings-title">
                  <h4 className="settings-property">Username</h4>
                  <span className="settings-property-info">
                    {user.userName}
                  </span>
                </div>
              </div>
              <div
                id="personal-info-settings-container-photo"
                className="not-700px"
              >
                <div className="settings-title">
                  <h4 className="settings-property">Photo</h4>
                  <div id="photo-settings-container">
                    <img
                      src={`https://api.dicebear.com/8.x/initials/svg?seed=${
                        user.firstName[0] + user.lastName[0]
                      }.svg`}
                      alt="profile"
                      id="profile-info-settings-photo"
                    />{" "}
                  </div>
                </div>
              </div>
              {editMode ? (
                <div>
                  <button
                    className="update-button"
                    onClick={updateProfileHandler}
                  >
                    UPDATE
                  </button>
                  <button
                    className="cancel-button"
                    onClick={() => {
                      setEditMode(false);
                    }}
                  >
                    CANCEL
                  </button>
                </div>
              ) : (
                <p id="account-last-updated">
                  Account last updated on:{" "}
                  <span id="date-updated">
                    {user.accountChangedOn.substring(0, 10)}
                  </span>
                </p>
              )}
            </div>
            <div id="security-container" className="settings-section-container">
              <div id="personal-info-header">
                <h3>Security:</h3>
              </div>
              <div id="security-info-settings">
                <div className="settings-title-security">
                  <h4 className="settings-property">Old Password</h4>
                  <input className="change-property" type="password"></input>
                </div>
                <div id="new-password">
                  <div>
                    <div className="settings-title-security">
                      <h4 className="settings-property">New Password</h4>
                      <input
                        className="change-property"
                        type="password"
                      ></input>
                    </div>
                  </div>
                  <div className="settings-title-security">
                    <h4 className="settings-property">Repeat New Password</h4>
                    <input className="change-property" type="password"></input>
                  </div>
                </div>
                {/* <button onClick={connectGoogleHandler} id="connect-google">Connect Google Account</button> */}
                <div style={{ marginLeft: "-2rem" }}>
                  <button className="update-button">UPDATE</button>
                  <button className="cancel-button">CANCEL</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
